export class AdvancePaymentDetails {
    advancePaymentId: number;
    stationId: number;
    accountExecutiveId: number;
    externalUserComments: string;
    totalAmount: number;
    createdBy: number;
    // 
    agencyAdvance: number;
    //  for adding Agency commision on db
    agencyCommission: number;  
    agencycomm : number;
    taxpercent : number;
    advanceTax : number;
    tax : number;

}
